import "./Image.css"

export default {
	name: "eiis-image",
	props: ['image', 'size'],
	data: function () {
		return {
			endpoint: "/api/media/images/",
		}
	},
	computed: {
		url: function() {
			var url = this.endpoint + this.image;
			if (this.size)
				url = url + "?size=" + this.size;
			return url;
		}
	},
	template: `
		<div class="eiis-image" 
			v-bind:id=image
			v-bind:aria-describedby=image >
			<img v-bind:src="url" v-bind:alt="image"/>
		</div>
	`
}
